import StyledLabel from "./StyledLabel";

const LabelWithError = ({ children, error, ...rest }) => (
  <div style={{ display: "flex", alignItems: "flex-end" }}>
    <StyledLabel {...rest}>{children}</StyledLabel>
    {error && (
      <span
        style={{
          color: "#B50444",
          marginLeft: "0.125rem",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "6.25rem" // adjust this value based on your needs
        }}
      >
        {error}
      </span>
    )}
  </div>
);

export default LabelWithError;
